/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 12c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm11.7 11.3-3-3c-.4-.4-1-.4-1.4 0l-5 5-.3.3V22h4.4l.3-.3 5-5c.4-.4.4-1 0-1.4zM15.6 20H14v-1.6l4-4 1.6 1.6zM3.9 16C2.6 17.4 2 19.1 2 21v1h2v-1c0-1.5.4-2.7 1.3-3.5.9-.9 2.4-1.5 4.7-1.5h1v-2h-1c-2.7 0-4.7.7-6.1 2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgContactEdit as ContactEdit };
